export default "https://assets-v2.scaler.com/packs/images/bolt.4c0f38.svg";